export const environment = {
  name: 'dev',
  production: false,
  pwa: true,
  appName: 'Learning Garden Dev',
  storageNamespace: 'learning-garden-dev'
} as const;
